import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import style from './footer.module.css';
import logoSrc from '../../assets/ai-logo.png';
import { iframeAtom,/*isSmallScreenAtom,*/ } from '../../store';
import { trackEvent } from '../../utils/trackEvent'
import { useSetRecoilState } from 'recoil';
import { RiBilibiliFill } from "react-icons/ri"
import { AiFillYoutube, AiOutlineTwitter } from "react-icons/ai"
import { PluginList } from '../../common/PlugIn';
import { useTranslation } from "react-i18next";


function Footer() {
    const setIframe = useSetRecoilState(iframeAtom)
    // const isSmallScreen = useRecoilValue(isSmallScreenAtom);
    const location = useLocation();
    const { t } = useTranslation();

    if (location.pathname === '/panorama') {
        return null;
    }


    const handlerOpenDeemos = () => {
        _czc.push(['_trackEvent', 'Index', 'Logo', 'Footer Component']);
        window.open('https://deemos.com', '_blank');
    }

    const handlerOpen = (target) => {
        trackEvent('Footer - Policy: Open', { openPage:target })
        setIframe({ type: 'Policy', src: `/${target}.html` })
        _czc.push(['_trackEvent', 'Index', `${target}`, 'Footer Component']);
    }

    const handlerOpenDoc = (target) => {
        trackEvent('Footer - Docs: Open', { openPage:target })
        setIframe({ type: 'Docs', src: `/${target}.html` })
        // window.history.pushState(null, '', `/product/${target?.toLowerCase()}`);
        _czc.push(['_trackEvent', 'Index', `${target}`, 'Footer Component']);
    }

    // handle the case when the user directly access the terms or privacy page
    useEffect(() => {
        switch (location.pathname) {
            case '/legal/terms':
                handlerOpen('Terms');
                break;
            case '/legal/privacy':
                handlerOpen('Privacy');
                break;
            case '/product/faq':
                handlerOpenDoc('FAQ');
                break;
            default:
                break;
        }
    }, [location.pathname]);

    if (location.pathname === '/panorama') {
        return null;
    }

    return (
        <footer className={style.con} id='footer'>
            { /* Byline Column */}
            <div className={`${style.col} ${style.byline}`}>
                {/* Produced by*/}
                <div className={style.productByline}>
                    {t('FOOTER_TITLE_1')}
                </div>
                <div
                    className={style.productBylineCompany}
                    onClick={handlerOpenDeemos}>
                    <img src={logoSrc} alt="Deemos Inc." />
                    &copy; Deemos, Inc.
                </div>
                <div className={style.productBylineCopyright}>
                    {t('FOOTER_TITLE_2')}.
                </div>
                <div className={style.spaceholder} />
                <div className={style.productBylineContact}>
                    <a
                        el="nofollow"
                        href="mailto:hello@deemos.com"
                        onPointerDown={() => {
                            _czc.push(['_trackEvent', 'Index', 'Contact', 'Footer Component']);
                        }}
                    >
                        hello@deemos.com
                    </a>
                </div>
                <div className={style.socialLinkWrapper} >
                    <div className={`${style.conItem} ${style.media}`}>
                        <a href="https://twitter.com/DeemosTech" target="_blank" rel="noreferrer">
                            <AiOutlineTwitter style={{ fontSize: '22px' }} />
                        </a>
                    </div>
                    <div className={`${style.conItem} ${style.media}`}>
                        <a href="https://www.youtube.com/@DeemosTech" target="_blank" rel="noreferrer">
                            <AiFillYoutube style={{ fontSize: '22px' }} /></a>
                    </div>
                    <div className={`${style.conItem} ${style.media}`}>
                        <a href='https://space.bilibili.com/1509136598' target="_blank" rel="noreferrer">
                            <RiBilibiliFill style={{ fontSize: '22px' }} />
                        </a>
                    </div>
                </div>
            </div>
            { /* Product Column */}
            <div className={style.col}>
                <div className={`${style.conColName}`}>
                    {t('FOOTER_PRODUCT')}
                </div>
                <div className={style.conItem}
                    onClick={handlerOpenDoc.bind(null, 'FAQ')}>
                    {t('FOOTER_PRODUCT_TIPS_1')}
                </div>
                <div className={style.conItem}>
                    <a href="/subscribe">{t('FOOTER_PRODUCT_TIPS_2')}</a>
                </div>
            </div>
            { /* Plugin Column */}
            <div className={style.col}>
                <div className={`${style.conColName}`}>
                    {t('FOOTER_PLUG_INS')}
                </div>
                {
                    PluginList.slice(0, PluginList.length - 1)
                        .filter(item => item.link)
                        .map((item, index) => {
                            return (
                                <div
                                    onClick={() => {
                                        window.open(item.link, '_blank');
                                    }}
                                    className={`${style.conItem} ${item.link ? "" : style.plugInInactive}`}
                                    key={index}
                                >
                                    {item.name}
                                </div>
                            );
                        })
                }
            </div>
            { /* Legal Column */}
            <div className={style.col}>
                <div className={`${style.conColName}`}>
                    {t('FOOTER_LEGAL')}
                </div>
                <div className={style.conItem} onClick={handlerOpen.bind(null, 'Privacy')}>
                    {t('FOOTER_LEGAL_TIPS_1')}
                </div>
                <div className={style.conItem} onClick={handlerOpen.bind(null, 'Terms')}>
                    {t('FOOTER_LEGAL_TIPS_2')}
                </div>
                {(!localStorage.getItem('defaultI18n') || localStorage.getItem('defaultI18n') === 'en') && <div className={`${style.conItem} whitespace-nowrap`} onClick={handlerOpen.bind(null, 'Fulfillment')}>
                    Fulfillment Policy
                </div>}
            </div>
        </footer>
    );
}

export default React.memo(Footer);
